import Cache from '../util/Cache';
import Cookie from '../util/Cookie';
import Api from '../util/Api';

const StoreService = {
    callback: {
        onchange: []
    },
    stores: [],
    activeStore: {
        id: '',
        address: '',
        name: ''
    },
    getStores() {
        if (Cookie.get('store_refresh') === false) {
            this.stores = false; // Cache.get('stores');
            this.activeStore = false; // Cache.get('activeStore');
        } else {
            this.stores = false;
            this.activeStore = false;
        }
        if (this.stores === false || this.activeStore === false) {
            return Api.get('/api/stores').then((response) => {
                this.stores = response.items;
                this.activeStore = this.stores.find(store => store.id == response.active);
                Cache.set('stores', this.stores);
                Cache.set('activeStore', this.activeStore);
                Cookie.remove('store_refresh');
            });
        }
        return new Promise(resolse => resolse());
    },
    setStore(id) {
        this.activeStore = this.stores.find(store => store.id == id);
        Cache.set('activeStore', this.activeStore);
        Cookie.set('store_id', id.trim(), false);
        this.callback.onchange.forEach((callback) => {
            callback(this.activeStore);
        });
    },
    onChange(callback) {
        this.callback.onchange.push(callback);
    }
};

window.store = StoreService;

export default StoreService;
